/**
 * LaunchDarkly gate for the Request Access surface — the
 * Request Access control on the connection page, the owner's management
 * page and route, and the two homepage count cards. LD key:
 * `om_tech_21418_request_access`; the React SDK camelCases flag keys, so
 * call sites read the camelCase form.
 *
 * Default OFF, and it must stay off-by-default for a reason beyond caution:
 * integration-service 404s every `/v1/accessRequest*` route while its own
 * copy of the flag is off, and its enable gate lets an unapproved enable
 * through. Showing a greyed Enable next to a Request Access button that
 * cannot succeed would strand a merchant who can enable perfectly well
 * today, so the portal gate has to fail closed in the same direction as the
 * backend's.
 */
export const REQUEST_ACCESS_FLAG = 'omTech21418RequestAccess';
export const REQUEST_ACCESS_FLAG_DEFAULT = false;
